export type DraftPreviewMoney = {
  amount: string;
  currency: string;
};

export type DraftPreviewContent = {
  label?: string;
  postContentFormatType?: string;
  /** Resolves to a platform/post-type name pair via `postTypeLookup`. */
  postTypeId?: string;
  /** `YYYY-MM-DD` — when the piece is due. */
  date?: string;
  /** The manual script, when there is one — the closest thing the draft has to
   * `ContentRequirementType.description` in a real campaign. */
  script?: string;
};

export type DraftPreviewPriceProductRef = {
  productId: string;
  quantity: number;
};

/**
 * The subset of the wizard's draft JSON this preview cares about. Deliberately its
 * own shape, not `NewCampaignSchema` — that type comes from a yup schema built to
 * *require* most of these fields, while the agent writes the draft incrementally and
 * this preview has to render something sane after every partial write.
 */
export type DraftPreviewModel = {
  name: string;
  description: string;
  object: string | null;
  productIds: string[];
  contents: DraftPreviewContent[];
  priceProduct: string | null;
  priceProductIds: DraftPreviewPriceProductRef[];
  giftCardPrice: DraftPreviewMoney | null;
  budgetType: string | null;
  fixedBudget: DraftPreviewMoney | null;
  rightsOfUse: string | null;
  /** Organic-only: how long the content must stay posted. */
  postInProfileTime: string | null;
};

export const EMPTY_DRAFT_PREVIEW: DraftPreviewModel = {
  name: "",
  description: "",
  object: null,
  productIds: [],
  contents: [],
  priceProduct: null,
  priceProductIds: [],
  giftCardPrice: null,
  budgetType: null,
  fixedBudget: null,
  rightsOfUse: null,
  postInProfileTime: null,
};
